import { sendRequest } from "@infrastructure/api/api";
import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    ReportSubGroupAssignmentResponse,
    ReportSubGroupResponse,
} from "@features/report/subgroup/types/reportSubGroup";

/** Convert booleans to 1/0 and strip null/undefined before URLSearchParams */
const toQueryString = (params: Record<string, any>) => {
    const query = new URLSearchParams();

    Object.entries(params ?? {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        query.set(key, typeof value === "boolean" ? (value ? "1" : "0") : String(value));
    });

    return query.toString();
};

export const fetchNationReportSubGroups = async (
    nationId: number,
    params: any
): Promise<ApiResponse<ReportSubGroupResponse>> => {
    const query = toQueryString(params);
    return sendRequest<any, ReportSubGroupResponse>(
        "GET",
        `nation/${nationId}/reportsubgroup/query${query ? `?${query}` : ""}`
    );
};

export const fetchTemplateReportSubGroups = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    params: any
): Promise<ApiResponse<ReportSubGroupAssignmentResponse>> => {
    const query = toQueryString(params);
    return sendRequest<any, ReportSubGroupAssignmentResponse>(
        "GET",
        `nation/${nationId}/department/${departmentId}/reporttemplate/${reportTemplateId}/reportsubgroup/query${query ? `?${query}` : ""}`
    );
};

export const createReportSubGroup = async (
    nationId: number,
    data: any
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<any, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/reportsubgroup/create`,
        data
    );
};

export const updateReportSubGroup = async (
    nationId: number,
    reportSubGroupId: number,
    data: any
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<any, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/reportsubgroup/${reportSubGroupId}/update`,
        data
    );
};

export const disableReportSubGroup = async (
    nationId: number,
    reportSubGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<never, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/reportsubgroup/${reportSubGroupId}/disable`
    );
};

export const enableReportSubGroup = async (
    nationId: number,
    reportSubGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<never, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/reportsubgroup/${reportSubGroupId}/enable`
    );
};

export const assignTemplateReportSubGroups = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    data: any
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<any, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/department/${departmentId}/reporttemplate/${reportTemplateId}/reportsubgroup/assign`,
        data
    );
};

export const removeTemplateReportSubGroups = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    data: any
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<any, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/department/${departmentId}/reporttemplate/${reportTemplateId}/reportsubgroup/remove`,
        data
    );
};
